import React from 'react';
import { HelpCircle, Book, MessageCircle, Mail, ExternalLink } from 'lucide-react';

export function HelpSupport() {
  const resources = [
    {
      title: 'Documentation',
      description: 'Browse our comprehensive guides and tutorials',
      icon: Book,
      link: '/docs',
    },
    {
      title: 'FAQ',
      description: 'Find answers to common questions',
      icon: HelpCircle,
      link: '/faq',
    },
    {
      title: 'Community Forum',
      description: 'Connect with other users and share knowledge',
      icon: MessageCircle,
      link: '/forum',
    },
    {
      title: 'Contact Support',
      description: 'Get help from our support team',
      icon: Mail,
      link: '/contact',
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Help & Support</h2>
        <p className="mt-1 text-sm text-gray-500">
          Find help and learn more about using Bidzora
        </p>
      </div>

      <div className="grid gap-6 sm:grid-cols-2">
        {resources.map((resource) => {
          const Icon = resource.icon;
          return (
            <div
              key={resource.title}
              className="group relative overflow-hidden rounded-lg border border-gray-200 bg-white p-6 shadow-sm transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div className="flex items-center space-x-4">
                <div className="rounded-lg bg-purple-100 p-3">
                  <Icon className="h-6 w-6 text-purple-600" />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900">{resource.title}</h3>
                  <p className="mt-1 text-sm text-gray-500">{resource.description}</p>
                </div>
              </div>
              <a
                href={resource.link}
                className="mt-4 inline-flex items-center text-sm font-medium text-purple-600 hover:text-purple-500"
              >
                Learn more
                <ExternalLink className="ml-2 h-4 w-4" />
              </a>
            </div>
          );
        })}
      </div>

      <div className="rounded-lg bg-purple-50 p-6">
        <h3 className="font-medium text-purple-900">Need Additional Help?</h3>
        <p className="mt-2 text-sm text-purple-700">
          Our support team is available Monday through Friday, 9AM-6PM EST.
          You can also email us at support@bidzora.com
        </p>
        <a
          href="mailto:support@bidzora.com"
          className="mt-4 inline-flex items-center rounded-lg bg-purple-600 px-4 py-2 text-sm font-medium text-white hover:bg-purple-700"
        >
          <Mail className="mr-2 h-4 w-4" />
          Contact Support
        </a>
      </div>
    </div>
  );
}